import { TRACK_OWNER_IDX } from '~/common/constants/constants';
import { MentorsPayload, AppLocalizationKey } from '~/common/types/types';
import mykytaRemeslov from '~/assets/img/mentors/mykyta-remeslov.png';
import vladyslavZubko from '~/assets/img/mentors/vladyslav-zubko.png';
import yelyzavetaVeis from '~/assets/img/mentors/yelyzaveta-veis.png';
import alinaKupchyk from '~/assets/img/mentors/alina-kupchyk.png';
import faridShabanov from '~/assets/img/mentors/farid-shabanov.png';
import anastasiiaChichik from '~/assets/img/mentors/anastasiia-chichik.png';
import nazarKovtun from '~/assets/img/mentors/nazar-kovtun.png';
import romanMykytka from '~/assets/img/mentors/roman-mykytka.png';
import oleksandraNedashkivska from '~/assets/img/mentors/oleksandra-nedashkivska.png';
import daniilTkalenko from '~/assets/img/mentors/daniil-tkalenko.png';
import sofiiaTrokhymchuk from '~/assets/img/mentors/sofiia-trokhymchuk.png';

const MENTORS = [
  mykytaRemeslov,
  vladyslavZubko,
  yelyzavetaVeis,
  alinaKupchyk,
  faridShabanov,
  anastasiiaChichik,
  nazarKovtun,
  romanMykytka,
  oleksandraNedashkivska,
  daniilTkalenko,
  sofiiaTrokhymchuk,
];

const mentorsPayload: MentorsPayload = {
  title: 'technology.js.mentors.title',
  items: MENTORS.map((it, idx) => ({
    name: `technology.js.mentors.mentor${idx}` as AppLocalizationKey,
    imgPath: it,
    isTrackOwner: idx === TRACK_OWNER_IDX,
  })),
};

export { mentorsPayload };
